import React, { Component } from 'react';
import styles from './fsp-tile-grid.scss';
import defaultStyles from '../../../Common/defaults.scss';
import FlexSetTile from '../flexSetTile/flex-set-tile';
import { IFspTileGridProps } from './fsp-tile-grid.d';

export default class FspTileGrid extends Component<IFspTileGridProps, { isDesktop: boolean, mounted: boolean }> {
    private breakpoint_tablet_max_width_1199 = parseInt(defaultStyles.breakpoint_tablet_max_width_1199);
    constructor(props) {
        super(props);
        this.state = {
            isDesktop: false,
            mounted: false
        };
    }

    componentDidMount(): void {
        // event handler is needed for tablet and mobile devices, desktop devices to not have publish of this event
        if (this.props.gridRef && this.props.gridRef.current) {
            this.props.gridRef.current.setAttribute('group', '');
        }

        if (window) {
            this.setState({
                mounted: true,
                isDesktop: window.innerWidth > this.breakpoint_tablet_max_width_1199
            });
        }
    }

    public render() {
        return (
                <div ref={this.props.gridRef ? this.props.gridRef : null}
                    className={styles.article_tile_grid_root} suppressHydrationWarning={true}>
                    {
                        this.props.flexSets.map((flexSet) => {
                            return (
                                <FlexSetTile
                                    portal={this.props.portal}
                                    culture={this.props.culture}
                                    flexibleSet={flexSet}
                                    isMobile={this.props.isMobile}
                                    isGlobal={this.props.isGlobal}
                                    isDesktop={this.state.isDesktop}
                                    l10n={this.props.l10n}
                                    currencyInformation={this.props.currencyInformation}
                                    addItemOriginToPdpLink={this.props.addItemOriginToPdpLink}
                                    key={flexSet.set.fsCode}
                                    isClientSide={this.state.mounted}
                                />
                            );
                        })
                    }
                </div>
        );
    }
}
